import { ISourceDataForm } from "@/api/dtos";
import { ISourceDataVerificationField, ISourceDataVerificationForm, ISourceDataVerificationSection, SourceDataType } from "@/utilities/forms/SourceDataFormProcessor";
import { useScopedField } from "@ngt/forms-core";
import { useMemo } from "react";

const useSourceDataFormReviewCount = (propertyPath: string, formInfo: ISourceDataVerificationForm) => {
    const { state: { value }} = useScopedField<ISourceDataForm>(propertyPath, { value: true }, false, true);

    const counts = useMemo(() => {
        if (!value) {
            return undefined;
        }

        let total = 0;
        let reviewed = 0;
        let verified = 0;
        let totalToReview = 0;
        let totalToVerify = 0;

        if (value.fields) {
            for (let field of Object.values(value.fields)) 
            for (let fieldRepeat of Object.values(field)){

                const fieldInfo = fieldRepeat.formSectionMetadataId ? 
                    (formInfo?.fields?.find(x => x.type === SourceDataType.Section && x.formSectionKey === fieldRepeat.formSectionMetadataId) as ISourceDataVerificationSection)?.fields?.find(x => x.type === SourceDataType.Field && x.formFieldKey === fieldRepeat.formFieldMetadataId) :
                    formInfo?.fields?.find(x => x.type === SourceDataType.Field && x.formFieldKey === fieldRepeat.formFieldMetadataId) as ISourceDataVerificationField

                total++;
                
                if (fieldInfo?.formFieldConfiguration?.allowSourceDataVerification && fieldInfo?.formFieldConfiguration?.allowReview) {
                    totalToReview++;

                    if (fieldRepeat.reviewed) {
                        reviewed++;
                    }
                }

                if (fieldInfo?.formFieldConfiguration?.allowSourceDataVerification && fieldInfo?.formFieldConfiguration?.allowVerify) {
                    totalToVerify++;

                    if (fieldRepeat.verified) {
                        verified++;
                    }
                }
            }
        }

        if (total > 0) {
            return {
                reviewed,
                verified,
                totalToReview,
                totalToVerify,
                total
            };
        }

        return undefined;
    }, [value])

    return counts;
}

export default useSourceDataFormReviewCount;